export const links = [
  {
    id: 1,
    text: "Map",
    path: "/map",
  },
]; 